import { Directive } from '@angular/core';
import { EventColorEnum } from '@sb/library/data-models';
import { CalendarEventKind, CalendarView } from '../definitions/calendar.definitions';
import { BaseViewComponent } from './base-view.component';

@Directive()
export abstract class CalendarBaseViewComponent extends BaseViewComponent {
    readonly CalendarView = CalendarView;
    readonly CalendarEventKind = CalendarEventKind;
    readonly CalendarEventColor = EventColorEnum;
}
